  let AUTH_API = "";
  let ZOOM_USER_API = "";
  let ZOOM_SDB_API = "";
  let GET_FORM_API = "";
  let GET_FORM_BY_PARAMS_API = "";
  let SUBMIT_API = "";
  let FORM_SETTINGS_API = "";
  let SUBMIT_SOAP_API="";

//const hostname = window.location.hostname;

   AUTH_API = "https://o1gxr2k611.execute-api.us-east-1.amazonaws.com/zoomAPIs";
   ZOOM_USER_API = "https://agpihkzh69.execute-api.us-east-1.amazonaws.com/zoomdata";
   ZOOM_SDB_API = "https://wikhlo9oc2.execute-api.us-east-1.amazonaws.com/cnpzoomapp";
   GET_FORM_API = "https://czgizz482a.execute-api.us-east-1.amazonaws.com/getformdetails";
   GET_FORM_BY_PARAMS_API = "https://xi1cvoj4f5.execute-api.us-east-1.amazonaws.com/zoom";
   SUBMIT_API = "https://utqnfro7z9.execute-api.us-east-1.amazonaws.com";
   FORM_SETTINGS_API = "https://rdiqsd9jy8.execute-api.us-east-1.amazonaws.com/zoom";
   SUBMIT_SOAP_API="https://hpbh657yp3.execute-api.us-east-1.amazonaws.com/submit";


export { AUTH_API, ZOOM_USER_API, ZOOM_SDB_API, GET_FORM_API, GET_FORM_BY_PARAMS_API, SUBMIT_API, FORM_SETTINGS_API, SUBMIT_SOAP_API };



export const IPQSKey = "AwTSkX9iOEW9zRAAnPqCYtIpE3S8qRntOgiz7ZYv23lXIj9FfnChQTnn6Z7s8D5FHZ1Lmylgwn5xIKbU9YPZ4SE4PV8t2nSEKkkBoRdIMYngt1WRcn3iGOLCEtE5Lydx1pZQhCv5pKikXuevjl09p9wxVQvKU7cMxH3krKnFn2laEukhflgGHgrfRlYflXxNzsvr9WFKbh7Z7C6vmeBwEx9cW8jwX4i3dUZLoKB26WGqJ5IdkpPwcbcCVmBD3phM";
export  const SALT_KEY = "gatheringjar$@0047";
export const CSS_PATH = "https://aws.assets.clickandpledge.com/zoomapp";






